module.exports = __webpack_public_path__ + "img/icon-chevron-down.990978c6.svg";